import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Row, Col, Button, Input } from "antd";
import { updateLabel } from "../../utils/api";
import { Spin } from "antd";
import { LoadingOutlined, EllipsisOutlined } from "@ant-design/icons";

import "./Label.css";
const antIcon = (
  <LoadingOutlined style={{ color: "white", fontSize: 20 }} spin />
);

function Label({}) {
  const [currentLabel, setCurrentLabel] = useState("");
  const [loading, setLoading] = useState("");
  const [userCode, setUserCode] = useState("");

  const stop = async () => {
    setLoading("stop");
    setCurrentLabel("");
    await updateLabel(userCode, "");
    setLoading("");
  };

  const onUpdateLabel = async (label) => {
    setLoading(label);
    try {
      setCurrentLabel(label);
      await updateLabel(userCode, label);
    } finally {
      setLoading("");
    }
  };

  return (
    <>
      <div className="Label">
        <Row>
          <Col>
            <Input
              type="text"
              placeHolder="User code"
              value={userCode}
              className="Label__input"
              block
              onChange={(e) => setUserCode(e.target.value)}
            ></Input>

            {userCode.length > 0 && (
              <>
                <Button
                  type="secondary"
                  className="Label__btn idle"
                  onClick={() => onUpdateLabel("idle")}
                  block
                >
                  {loading === "idle" && (
                    <Spin className="Label__spin" indicator={antIcon} />
                  )}{" "}
                  Idle {currentLabel==="idle" && <EllipsisOutlined />}
                </Button>
                <Button
                  type="secondary"
                  className="Label__btn walk"
                  onClick={() => onUpdateLabel("walk")}
                  block
                >
                  {loading === "walk" && (
                    <Spin className="Label__spin" indicator={antIcon} />
                  )}{" "}
                  Walk {currentLabel==="walk" && <EllipsisOutlined />}
                </Button>
                <Button
                  type="secondary"
                  className="Label__btn run"
                  onClick={() => onUpdateLabel("run")}
                  block
                >
                  {loading === "run" && (
                    <Spin className="Label__spin" indicator={antIcon} />
                  )}{" "}
                  Run {currentLabel==="run" && <EllipsisOutlined />}
                </Button>
                <Button
                  type="secondary"
                  className="Label__btn drive"
                  onClick={() => onUpdateLabel("drive")}
                  block
                >
                  {loading === "drive" && (
                    <Spin className="Label__spin" indicator={antIcon} />
                  )}{" "}
                  Drive {currentLabel==="drive" && <EllipsisOutlined />}
                </Button>
                <Button
                  type="secondary"
                  className="Label__btn stop"
                  onClick={() => stop()}
                  block
                >
                  {loading === "stop" && (
                    <Spin className="Label__spin" indicator={antIcon} />
                  )}{" "}
                  Stop
                </Button>
              </>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
}

export default observer(Label);
